import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-6.png');

class Specialization3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="section-head m-b50 text-white text-center">
                                <h3 className="m-t0">Real Estate Development and the EB-5 Program</h3>
                                <p>The EB-5 Program was established to facilitate job creation in the United States. While real estate developments have historically been limited in their ability to create the requisite number of jobs per investor as a result of regulatory limitations, these developments currently comprise a large number of EB-5 investment projects.

Learn about the Trivik Builders EB-5 Investment Program and invest in your future today. Invest with us and get your Green Card.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/1.jpg')}  alt=""/>
                                        <div className="figcaption">
                                            <h4>Apex Townhomes – Manchester CT</h4>
                                            <p>37 Townhomes ground-up construction project

Oakland Street is a high-traffic road with lots of commercial and apartment complexes

Very close to Highways 84, 291, and 384</p>
                                            {/* <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/2.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>Bidwell Commons – Manchester CT</h4>
                                            <p>26 Townhomes ground-up construction project

Property close to Hartford, CT, and other amenities

Very Close Highways 84, 384, and 291</p>
                                            {/* <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/3.jpg')} alt=""/>
                                        <div className="figcaption bg-dark">
                                            <h4>Southside Meadows – Elgin TX</h4>
                                            <p>$60M project. 174.01 acres. 680 Single-family lots.

Very close to HWY 290, Walmart, HEB and Schools.

LOI’s in place from National Builders for Sale of the lots.

Several neighborhoods are coming in Elgin and Manor areas.

</p>
                                            {/* <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization3;